<template>
    <div class="collaspable-sidebar-container" :class="{ open }">
        <div class="collaspable-sidebar">
            <div class="row">
                <div class="col-xs-8">
                    <h5 class="_margin-top-30">Filter Your Results</h5>
                </div>

                <div class="col-xs-4">
                    <button type="button" name="close" class="close" @click="open = false">
                        &times;
                        <span class="sr-only">Close sidebar</span>
                    </button>
                </div>
            </div>

            <label for="suppliers">Suppliers</label>
            <div class="row">
                <div class="col-xs-4 _margin-bottom-10" v-for="s in filters.suppliers" :key="s.id" v-if="isBig6(s.id)">
                    <label class="company-logo-xs" :class="{ selected: s.selected }" :for="s">
                        <input :id="s.id" :name="s.name" type="checkbox" v-model="s.selected" />
                        <supplier-logo :id="s.id"></supplier-logo>
                    </label>
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12 _margin-bottom-30">
                    <uiv-dropdown ref="dropdown" :not-close-elements="ele">
                        <uiv-btn type="ghost" block size="sm">
                            Filter by supplier
                        </uiv-btn>
                        <template slot="dropdown">
                            <li>
                                <checkbox :id="s.name" v-for="s in filters.suppliers" :key="s.id" v-model="s.selected"
                                    class="_margin-bottom-10">
                                    {{ s.name }}
                                </checkbox>
                            </li>
                        </template>
                    </uiv-dropdown>
                </div>
            </div>

            <label for="paymentMethod">Payment Type</label>
            <div class="row _margin-bottom-30">
                <div class="col-xs-12">
                    <select-list id="paymentMethod" v-model="filters.payMethod" value-key="name"
                        :list="paymentMethodList" />
                </div>
            </div>

            <label for="rateType">Rate Type</label>
            <div class="row _margin-bottom-30">
                <div class="col-xs-12">
                    <select-list id="rateType" v-model="filters.isFixed" value-key="name" :list="rateTypeList" />
                </div>
            </div>

            <div class="row _margin-bottom-30">
                <div class="col-xs-12">
                    <label for="green">Green Tariffs</label>
                    <select-list id="green" v-model="filters.isGreen" :list="greenTariffList" />
                </div>
            </div>

            <div class="row">
                <div class="col-xs-12">
                    <radio id="switchable_yes" v-model="filters.switchable" :value="true" class="_margin-bottom-10">
                        Only show plans {{ app_settings.supplierName }} can help me switch to
                    </radio>

                    <radio id="switchable_no" v-model="filters.switchable" :value="false">
                        Include plans that require switching directly through the supplier
                    </radio>

                    <div class="_margin-top-20">
                        <small v-if="filters.switchable">
                            You're currently viewing <b>{{ results.length }}</b> plan{{ results.length > 1 ? 's' : '' }}
                            {{
                                app_settings.supplierName }} can help you switch to.
                            To include plans that require switching directly through the supplier use the filter above.
                        </small>

                        <small v-else>
                            Your current view includes plans that require switching directly through the supplier
                        </small>
                    </div>
                </div>
            </div>

            <div class="row _margin-top-30">
                <div class="col-xs-6">
                    <uiv-btn type="link" @click="onReset()">
                        Reset
                    </uiv-btn>
                </div>

                <div class="col-xs-6 text-right">
                    <uiv-btn type="primary" block @click="open = false">
                        Done
                    </uiv-btn>
                </div>
            </div>
        </div>
        <div class="backdrop" @click="open = false"></div>
    </div>
</template>

<script>
import { mapState, mapGetters, mapActions } from 'vuex';
import SupplierLogo from '../../../../base/components/supplier-logo/SupplierLogo';

export default {
    name: 'CollaspableSidebar',
    data() {
        return {
            open: false,
            ele: []
        };
    },
    mounted() {
        this.ele.push(this.$refs.dropdown.$el);
        this.filters.payMethod = this.lowerCaseFirstLetter(this.defaultPaymentMethod);
    },
    computed: {
        ...mapState({
            defaultPaymentMethod: ({ storage }) => storage.quote.proposedPayMethod,
            paymentMethodList: ({ lookups }) => lookups.paymentMethods,
            rateTypeList: ({ lookups }) => lookups.rateTypes,
            greenTariffList: ({ lookups }) => lookups.greens,
            filters: ({ quote_results }) => quote_results.filters,
            big6: ({ quote_results }) => quote_results.big6,
            app_settings: ({ app_settings }) => app_settings
        }),
        ...mapGetters({
            results: 'quote_results/results'
        }),
        selectedSuppliers() {
            return this.filters.suppliers.filter(({ selected }) => selected).length;
        }
    },
    methods: {
        isBig6(id) {
            return this.big6.indexOf(id) > -1;
        },
        async toggleOpen() {
            this.open = !this.open;

            this.$store.dispatch('tracing/addAction', { name: 'Page', value: 'Quote Results' });
            this.$store.dispatch('tracing/addAction', { name: 'Action', value: `Sidebar ${this.open ? 'Open' : 'Close'}` });
            await this.$store.dispatch('tracing/saveActions');
        },
        lowerCaseFirstLetter(val) {
            return `${val}`.charAt(0).toLowerCase() + `${val}`.slice(1);
        },
        onReset() {
            this.filters.suppliers = this.filters.suppliers.map(item => ({
                ...item, selected: false
            }));
            this.filters.isFixed = 'any';
            this.filters.isGreen = 'any';
            this.filters.switchable = true;
            this.filters.payMethod = this.defaultPaymentMethod;
        }
    },
    components: {
        SupplierLogo
    }
};
</script>

<style lang="scss" src="./collaspable-sidebar.scss"></style>
